import { extend } from 'vee-validate'
import { rules } from 'ifield-core-components'

// ルール登録
Object.keys(rules).forEach((rule) => {
  rule !== 'default' && extend(rule, rules[rule])
})
